<template>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tabvertical">
    <c-tab
      ref="nearmissTab"
      type="vertical"
      :tabItems="tabItems"
      :height="tabHeight"
      v-model="tab"
    >
      <template v-slot:default="tab">
        <component
          :is="tab.component"
          :tabParam="tabParam"
          :grid.sync="grid"
          :imprTabInfo.sync="imprTabInfo"
          :contentHeight="contentHeight"
          @closePopup="closePopup"
          @changeStatus="changeStatus"
          @getDetail="getDetail"
        />
      </template>
    </c-tab>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'cto-tab',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        sopCtoId: '',
      }),
    },
    contentHeight: null, 
  },
  data() {
    return {
      grid: {
        columns: [],
        data: [],
        height: 'auto',
      },
      tabParam: {
        sopCtoId: '',
        plantCd: '',
        ctoDate: '',
        ctoTime: '',
        observeUserId: '',
        observeCount: '',
        mdmSopId: '',
        workArea: '',
        ctoCompleteFlag: 'N',
        improveContents: '',
        priorityContents: '',
        managerUserId: '',
        sopName: '',
        processName: '',
        regUserId: '',
        chgUserId: '',
        workCharacteristics: '',
        humanFactors: '',
        coreActionItems: '',
        activityModels: [],
        ctoChecklistModels: [],
        ctoImproveModels: [],
        ctoPenaltyModels: [],
      },
      editable: true,
      completeUrl: '',
      completeType: 'POST',
      isComplete: false,
      insertUrl: '',
      deleteUrl: '',

      splitter: 5,
      tab: 'ctoInfo',
    };
  },
  computed: {
    disabled() {
      return Boolean(!this.popupParam.sopCtoId) || this.tabParam.ctoCompleteFlag === 'Y'
    },
    tabItems() {
      return [
        { key: uid(), name: 'ctoInfo', icon: 'edit', label: '기본정보', component: () => import(`${'./ctoInfo.vue'}`) },
        { key: uid(), name: 'ctoChecklist', icon: 'how_to_reg', label: '체크리스트', component: () => import(`${'./ctoChecklist.vue'}`), disabled: (this.popupParam.sopCtoId ? false : true) },
        // { key: uid(), name: 'ctoPenalty', icon: 'person_off', label: '사용자별 페널티', component: () => import(`${'./ctoPenalty.vue'}`), disabled: (this.popupParam.sopCtoId ? false : true) },
        { key: uid(), name: 'ctoFile', icon: 'camera_enhance', label: '첨부파일', component: () => import(`${'./ctoFile.vue'}`), disabled: (this.popupParam.sopCtoId ? false : true) },
        // { key: uid(), name: 'ctoFile2', icon: 'auto_fix_normal', label: '기존<br/>개선사항', component: () => import(`${'./ctoCausePrevention.vue'}`), disabled: (this.popupParam.sopCtoId ? false : true) },
        // { name: 'ctoCause', icon: 'camera_enhance', label: '총평 / 근본원인', component: () => import(`${'./ctoCause.vue'}`), disabled: (this.popupParam.sopCtoId ? false : true) },
        { key: uid(), name: 'impr', icon: 'construction', label: '개선관리', component: () => import(`${'@/pages/common/ibm/imprTab.vue'}`), disabled: (this.popupParam.sopCtoId ? false : true) },
      ]
    },
    tabHeight() {
      return String(this.contentHeight - 36);
    },
    imprTabInfo() {
      return {
        key: this.tabParam.sopCtoId, // 
        ibmTaskTypeCd: 'ITT0000060',
        isPreview: true,
        requestContents: this.tabParam.mdmSopId,
        disabled: (this.tabParam.ctoCompleteFlag === 'Y'),
        isOld: Boolean(this.popupParam.sopCtoId),
        gridItem: {
          listUrl: selectConfig.sop.cto.improve.get.url,
          param: {
            sopCtoId: this.popupParam.sopCtoId,
          },
          title: '체크리스트별 별 개선사항 목록',
          merge: [
          ],
          columns: [
            {
              name: 'checklistName',
              field: 'checklistName',
              label: '체크리스트 항목',
              align: 'left',
              style: 'width:400px',
              sortable: false,
            },
            {
              name: "selectValueName",
              field: "selectValueName",
              label: "양호/불량/해당없음",
              style: 'width:100px',
              align: "center",
              setHeader: true,
              sortable: false,
            },
          ],
          research: this.research,
        },
        gridOther: {
          title: '항목외 개선 목록',
        },
      }
    }
  },
  watch: {
    height() {
      let numHeight = this.height ? Number(this.$_.replace(this.height, 'px', '')) : 600;
      numHeight = numHeight - 40
      this.tabHeight = numHeight + 'px';
    },
    'tabParam'() {
      this.$emit('transInfo', this.tabParam);
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.getUrl = selectConfig.sop.cto.basic.get.url;
      this.insertUrl = transactionConfig.sop.cto.basic.insert.url;
      this.completeUrl = transactionConfig.sop.cto.basic.complete.url;
      this.deleteUrl = transactionConfig.sop.cto.basic.delete.url;
      // code setting
      // list setting
      this.getDetail();
    },
    getDetail() {
      if (this.popupParam.sopCtoId) {
        this.$http.url = this.$format(this.getUrl, this.popupParam.sopCtoId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.tabParam = _result.data;
          this.updateMode = true;
        },);
      } else {
        this.$set(this.tabParam, 'ctoDate', this.$comm.getToday())
        this.$set(this.tabParam, 'observeUserId', this.$store.getters.user.userId)
      }
    },
    closePopup(data) {
      this.$emit('closePopup', data);  
    },
    changeStatus(data) {
      this.$emit('changeStatus', data)
      this.popupParam.sopCtoId = data;
      this.getDetail();
    },
  }
};
</script>
